var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_49_260",
    transform: "scale(0.00735294)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_49_260",
    width: 136,
    height: 136,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIgAAACICAYAAAA8uqNSAAAEnElEQVR4nO3dT2tcVRjH8d/TpJQsu+ss4la6cuuy7voCOhaLoi2l/qF3LIpWxD/TmmozU2sJTSSNRSk0mXsVEREVRKoouXkJNtO3IYhm7nGhhWjxTJI5c85N/H5ewPM80C93hmkmkQAAAAAAAAAAAAAAALCX2KgDzj/x8J0Qh2A4My1cXr77acydkzGXYeec0/zsyt3PYu/dF3shts85zXd68eOQCKT2UsYhEUitpY5DIpDaqkMcEoHUUl3ikAikdkLGsbh4Zv+oMwikRkLGcad9ZPKRgweWR53D5yA1ETKOomhOTKmxLOnYqLN4gtRA6Dimdei2pGaIeTxBEgsfR+OWScdDzJN4giQVPA7X+MSkEyHm3UcgiYzhZeUjMz0ZYt5mBJJAyDjabe2bdo0lkz0TYt6/8R4kssAfgtnRw9mSTCcDzXtA8kBmV+4+lvqGXcrKPLshs1PjXJI8EOyIreXZhzI7Pe5FBLL7WFlk85I9G2MZb1J3FyuLbM5kz8dayBNk97DVovWBSWdjLiWQXWItz65KejH2XgLZBcoie1+ycyl2E0jNrRVZR7KXUu3nTWqNlXl2WbJXUt5AIDVV5tklMzuf+o7ELzH2R9r99bSaty6a6fXUd0jJA9HviffXTpm32mZ6M/Ud9/ESUzNmejv1DZsRCLwIBF4EAi8CgReBwItA4EUg8Er9QVlwsX9n2l7/mVqeIPAiEHgRCLwIBF4EAi8CgReBwItA4EUg8EociPst7X4Mk/oJMki8H0OkDgQ1RyDwIhB4EQi8CAReBAIvAoEXgcCLQOBFIPAiEHgRCLwIBF4EAi8CgReBwGvPfTd3r39XNjaeIPBKHcivifdjiNSBuMT7MUTqQFBzBAIvAoEXgcCLQOBFIPAiEHgRCLySBWJmG3J2M9V+bE2S/6wzsw3nqguzvfXVFPuxddEDMbONQVVd7PbWf469G9sXNxDTYOA2Zrq9ez9F3YsdixlIZZXNdHv3foy4EyOKFUjlBpqZLX75IdI+BBIjkMo5926nWI/6VxgQxrgDqZyqy51e//sx78GYjDOQqpK63ZX+d6EGrhXZBcneCjUPw40nEJPTwF3p5uvfhhpZ5tk7kr0Rah62JnwgJlfJXenm69+EGlnm2SUzq8Xfsv+/CRuIyVWD6mo3738dauRq0XrPpNdCzcP2hAvE5Fyla928/1WokWXemjXp1VDzsH1hAjE559xcp7f+ZZB5kso8u2Kml0PNw86MHojJuUF1vZP3vwhwjyTZWp5dldm5QPMwgpEDcZUWOnn/8xDHSLIyz67JrBVoHkZkqQ/YxMoimzPZ2dSH7CWPPj430r9xXb68bWXeum7SC6kPwT/VIRAr89aCmZ5LfQgelDoQK/PshplOJ74D/yFZIO229h09nC3J7FSqGzBckkCKojkx7RpLMp1MsR9bFz2Qv+O4aaanY+/G9kUNpCiaEw/p0McyPRVzL3YuWiBF0ZyYVuOWpBOxdmJ0UQL5K45Dt006HmMfwhl7IHfaRyan1FiW1Bz3LoQ31kAWF8/snzp4YFnSsXHuAQAAAAAAAAAAAAAAALA1fwLMDkFYJJk0fAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdc);
export default __webpack_public_path__ + "static/media/Icon_Adc.aa2924500c5835ceb441555b5a346a64.svg";
export { ForwardRef as ReactComponent };